var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#cfccec",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M103.5,59.45c0-2.74.02-5.56.02-8.35,0-.74-.17-2.62-1.74-4.18-1.56-1.56-3.45-1.74-4.19-1.74h-3.63v-2.04c0-3.27-2.66-5.92-5.92-5.92h-2.9c-3.27,0-5.92,2.66-5.92,5.92v12.34h-31.44v-12.35c0-3.27-2.66-5.92-5.92-5.92h-2.9c-3.27,0-5.92,2.66-5.92,5.92v2.04h-3.65c-3.59.06-5.91,2.38-5.9,5.92v25.04c0,.74.16,2.62,1.73,4.19s3.45,1.74,4.19,1.74h3.63v2.04c0,3.27,2.66,5.92,5.92,5.92h2.9c3.27,0,5.92-2.66,5.92-5.92v-12.34h31.43v12.34c0,3.27,2.66,5.92,5.92,5.92h2.9c3.27,0,5.92-2.66,5.92-5.92v-2.04h3.65c2.51-.05,3.93-1.21,4.67-2.18.79-1.04,1.24-2.4,1.23-3.75-.05-5.55-.03-11.2,0-16.67ZM98.32,51.1v25.04c0,.4-.33.73-.73.73h-3.63v-26.49h3.63c.4,0,.73.33.73.73ZM84.41,43.13c0-.4.33-.73.73-.73h2.9c.4,0,.73.33.73.73v40.97c0,.4-.33.73-.73.73h-2.9c-.4,0-.73-.33-.73-.73v-40.97ZM79.21,60.67v5.9h-31.43v-5.9h31.43ZM38.24,43.14c0-.4.33-.73.73-.73h2.9c.4,0,.73.33.73.73v40.96c0,.4-.33.73-.73.73h-2.9c-.4,0-.73-.33-.73-.73v-40.96ZM28.68,51.11c0-.4.33-.73.73-.73h3.63v26.49h-2.31s-1.32,0-1.32,0c-.4,0-.73-.33-.73-.73v-25.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.65d2ba7380d5b55d94d05d45d18fa7f7.svg";
export { ForwardRef as ReactComponent };